import { journalistRegistration, postReq } from 'api';
import { EmailRegEx, PasswordRegEx } from 'data/globalConstants';
import FormWithSidebar from 'components/FormWithSidebar';
import { useForm } from 'react-hook-form';

import { common, registration as content, validation } from 'lang/en.json';
import { authenticate, authSelector, handleAuthorization } from 'store/auth';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { useRouter } from 'next/router';

const RegisterJournalist = ({ state: { setFormData, formData } }) => {
    const { register, handleSubmit, getValues, errors, setError, setValue } =
        useForm();
    const dispatch = useDispatch();
    const router = useRouter();
    const { error } = useSelector(authSelector);
    const [loading, setLoading] = useState(false);

    const onSubmit = async (data) => {
        const { email, captchaToken } = data;
        const {
            data: { success },
        } = await postReq('/auth/check-email', { email, captchaToken });

        if (success) {
            setError('email', {
                type: 'manual',
                message: validation.emailExists,
            });
            return;
        }

        const cleanData = {
            email: data.email,
            password: data.password,
            ...router.query,
            subscribeMarketing: true,
            ...router.query,
            captchaToken: data.captchaToken,
        };

        const res = await journalistRegistration(cleanData);
        if (!res.data || res.data.errors) {
            return null;
        }
        if (res.data) {
            // LOGIN
            await dispatch(
                authenticate({
                    password: data.password,
                    email: data.email,
                })
            );
            if (error) {
                return console.error(error);
            }
            dispatch(handleAuthorization());
            setLoading(false);
            router.push('/');
        } else {
            console.error(data); // eslint-disable-line
        }
    };

    const inputs = [
        {
            type: 'email',
            label: 'Email address',
            name: 'email',
            error: errors['email'],
            register: register({
                required: validation.required,
                pattern: {
                    value: EmailRegEx,
                    message: validation.email,
                },
            }),
        },
        {
            type: 'password',
            label: 'Password',
            name: 'password',
            error: errors['password'],
            register: register({
                required: validation.required,
                pattern: {
                    value: PasswordRegEx,
                    message: validation.password,
                },
            }),
        },
        {
            type: 'password',
            label: 'Re-type password',
            name: 'passwordConfirm',
            error: errors['passwordConfirm'],
            register: register({
                required: validation.required,
                validate: (value) => {
                    const { password } = getValues();
                    return password === value || validation.passwordMatch;
                },
            }),
        },
        {
            type: 'hidden',
            name: 'captchaToken',
            register: register('captchaToken'),
        },
        {
            component: 'button',
            title: common.continue,
        },
    ];

    const form = {
        title: `Real time ACCESS TO 000s <br> of REAL BUSINESS OWNERS`,
        walkthrough:
            'Creating a Newspage enables you to get the views of thousands of experts on countless subject matters in minutes, and access to endless case studies.',
        controls: true,
        onSubmit: handleSubmit(onSubmit),
        setValue,
        inputs,
    };

    const list = content.screen_1.walkthrough.list.reduce((acc, item) => {
        return acc + `<li>${item}</li>`;
    }, []);

    const quote = {
        quote: `"Newspage has been a lifesaver. It provides me with a fast and straightforward way to connect with experts in their field, who can offer exactly the sort of insights my readers want."`,
        author: {
            image: '/tracy_lynn.jpg',
            name: 'John Fitzsimmons',
            sub: 'Freelance',
        },
    };

    const sidebar = {
        quote,
        topTips: [
            {
                icon: {
                    variant: 'small',
                    src: '/icons/top-tips/headlines.svg',
                },
                small: 'Top tip',
                title: 'Why use Newspage?',
                body: 'Newspage gives you a massive diversity of voices to quote in your stories from experts in all corners of the UK. And they appear in one place, in real time.',
            },
        ],
    };

    const errorsOrdered = inputs.reduce((result, item) => {
        if (errors[item.name]) {
            result.push(errors[item.name]);
        }
        return result;
    }, []);

    return (
        <FormWithSidebar
            data={{
                form,
                sidebar,
                errors: errorsOrdered,
            }}
        />
    );
};

export default RegisterJournalist;
